export enum ModalTheme {
  DEFAULT = '#f6f6f6',
  LIGHT = '#fff',
  ADJUST_DEAL = '#e7e7e7',
}
